export default __webpack_public_path__ + "images/online-payment/verified-by-visa.svg?7875a036cf9b96ea1a1f0f952438542537f1807a133fda2c961823c6425802eb";